import { Stack, StackProps } from '@chakra-ui/react';

export default function FormControlGroup({children, ...props}: StackProps) {
  return (
    <Stack
      spacing="32px"
      direction="row"
      {...props}
    >
      {children}
    </Stack>
  )
}
